import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-secondary-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './secondary-button.component.html',
  styleUrl: './secondary-button.component.css'
})
export class SecondaryButtonComponent {
  @Input() buttonText: string = '';
  @Input() isDisabled: boolean = false;
  @Output() buttonClick = new EventEmitter<void>();

  // Color inputs
  @Input() backgroundColor: string = 'bg-white';
  @Input() textColor: string = 'text-black';
  @Input() borderColor: string = 'border-border';

  @Input() hoverBackgroundColor: string = 'hover:bg-primary';
  @Input() hoverTextColor: string = 'hover:text-white';
  @Input() hoverBorderColor: string = 'hover:border-primary';

  @Input() disabledBackgroundColor: string = 'bg-neutral-800';
  @Input() disabledTextColor: string = 'text-neutral-300';
  @Input() disabledBorderColor: string = 'border-neutral-300';

  @Input() fontWeight: string = 'font-medium';

  onClick() {
    if (!this.isDisabled) {
      this.buttonClick.emit();
    }
  }
}
